// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import UploaderForm from '../components/UploaderForm';
import DeleteUploader from './DeleteUploader';
import {
  saveUploader,
  getUploaderById,
} from '../../../../actions/uploaderActions';
import Loading from '../../../common/Loading';
import { getAllWorkflows } from '../../../../actions/workflowActions';
import { getKeyProviders } from '../../../../actions/keyProviderActions';
import { getPlatforms } from '../../../../actions/platformActions';
import { getUserProfileGroups } from '../../../../actions/userProfileGroupActions';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import SlidingPane from 'react-sliding-pane';
import { getCompanyIdsForAnyPermission } from '../../../auth/authUtils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { fetchCompanies } from '../../../../reducers/companyReducer';

function Uploader({
  done,
  id,
  cancel,
  workflows,
  getAllWorkflows,
  keyProviders,
  getKeyProviders,
  platforms,
  getPlatforms,
}) {
  const dispatch = useAppDispatch();
  const companies = useAppSelector((state) => state.companies);
  const currentUser = useAppSelector((state) => state.auth);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    getValues,
    clearErrors,
    setValue,
    watch,
  } = useForm();

  //companies
  useEffect(() => {
    if (!companies) {
      dispatch(fetchCompanies());
    }
  }, [companies, dispatch]);

  const [allowedPublishers, setAllowedPublishers] = useState();
  useEffect(() => {
    let pubs = getCompanyIdsForAnyPermission(currentUser);
    setAllowedPublishers(pubs);
  }, [companies, currentUser]);

  const onSubmit = (data) => {
    if (!uploader) {
      toast.error(t('Failed to save uploader'));
      return;
    }

    saveUploader({ ...data, id: uploader.id })
      .then(() => {
        setUploader({ ...data, id: uploader.id });
        done();
        toast.success(t('Uploader saved'));
      })
      .catch(() => {
        toast.error(t('Failed to save uploader'));
      });
  };

  const [deleteSlideoutOpen, setDeleteSlideoutOpen] = useState(false);
  const handleDelete = (e) => {
    e.cancelBubble = true;
    setDeleteSlideoutOpen(true);
    return false;
  };

  const [uploader, setUploader] = useState();

  useEffect(() => {
    if (id) {
      getUploaderById(id)
        .then((d) => {
          setUploader(d);
        })
        .catch((e) => {
          console.error(e);
          navigate('/settings/uploaders/');
          toast.error(t('Uploader not found'));
        });
    }
  }, [id, navigate, t]);

  useEffect(() => {
    if (!workflows) {
      getAllWorkflows();
    }
  }, [workflows, getAllWorkflows]);

  useEffect(() => {
    if (!keyProviders) {
      getKeyProviders();
    }
  }, [keyProviders, getKeyProviders]);

  useEffect(() => {
    if (!platforms) {
      getPlatforms();
    }
  }, [platforms, getPlatforms]);

  const [groups, setGroups] = useState();
  useEffect(() => {
    if (!groups) {
      // get the groups
      getUserProfileGroups()
        .then((d) => {
          setGroups(d.data);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, [groups]);
  return uploader && workflows && keyProviders && platforms && groups ? (
    <>
      <SlideoutLayout
        title={t('Edit uploader')}
        cancel={cancel}
        done={done}
        bar={
          <>
            <input
              type="button"
              value={t('Delete')}
              className="btn btn-danger me-2"
              onClick={handleDelete}
            />
            <input
              type="submit"
              value={t('Save')}
              className="btn btn-primary"
              onClick={handleSubmit(onSubmit)}
            />
          </>
        }
      >
        <UploaderForm
          uploader={uploader}
          register={register}
          errors={errors}
          control={control}
          getValues={getValues}
          setValue={setValue}
          watch={watch}
          workflows={workflows}
          clearErrors={clearErrors}
          keyProviders={keyProviders}
          platforms={platforms}
          groups={groups}
          companies={companies}
          allowedPublishers={allowedPublishers}
        ></UploaderForm>
      </SlideoutLayout>

      <SlidingPane
        isOpen={deleteSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setDeleteSlideoutOpen(false)}
      >
        <DeleteUploader
          id={id}
          done={(d) => {
            setDeleteSlideoutOpen(false);
            done();
          }}
          cancel={() => setDeleteSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  ) : (
    <Loading></Loading>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    workflows: state.workflows,
    keyProviders: state.keyProviders,
    platforms: state.platforms,
  };
}

const mapDispatchToProps = {
  getAllWorkflows,
  getKeyProviders,
  getPlatforms,
};

export default connect(mapStateToProps, mapDispatchToProps)(Uploader);
